(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9306],{

/***/ 82887:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hospitals/[hospitalPid]",
      function () {
        return __webpack_require__(77042);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 46092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ FaceToFaceDdAction; }
/* harmony export */ });
var FaceToFaceDdAction;
(function(FaceToFaceDdAction) {
    FaceToFaceDdAction["ClickReservationStart"] = "f2f-click-reservationStart";
    FaceToFaceDdAction["ClickDepartment"] = "f2f-click-department";
    FaceToFaceDdAction["ClickDate"] = "f2f-click-date";
    FaceToFaceDdAction["ClickTimeLine"] = "f2f-click-timeLine";
    FaceToFaceDdAction["ClickDoctor"] = "f2f-click-doctor";
    FaceToFaceDdAction["ClickReservationComplete"] = "f2f-click-reservationComplete";
    FaceToFaceDdAction["CloseErrorModal"] = "f2f-close-errorModal";
    FaceToFaceDdAction["ClickReservationStartWithNoAuth"] = "f2f-click-reservationStart-noauth";
    FaceToFaceDdAction["ClickCallReservation"] = "f2f-click-call-reservation";
    FaceToFaceDdAction["ClickCallReservationPartner"] = "f2f-click-call-reservationPartner";
    FaceToFaceDdAction["ClickCallHospital"] = "f2f-click-call-hospital";
    FaceToFaceDdAction["PageViewHospitalDetail"] = "f2f-pageview-hospitalDetail";
    FaceToFaceDdAction["ClickEventButton"] = "f2f-click-event-button";
    FaceToFaceDdAction["F2fPharmacyConfirmButtonClick"] = "f2f_pharmacy_confirm_button_click";
    FaceToFaceDdAction["F2fHospitalConfirmButtonClick"] = "f2f_hospital_confirm_button_click";
    FaceToFaceDdAction["F2fDiagnosisConfirmButtonClick"] = "f2f_diagnosis_confirm_button_click";
    FaceToFaceDdAction["F2fPreferenceStepSubmitButtonClick"] = "f2f_preference_step_submit_button_click";
})(FaceToFaceDdAction || (FaceToFaceDdAction = {}));


/***/ }),

/***/ 56478:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ EDoctorPartnershipStatus; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(70865);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96670);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22970);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72271);
/* harmony import */ var _shared_utils_typeGuard__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95214);
/* harmony import */ var _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(38245);







var EDoctorPartnershipStatus;
(function(EDoctorPartnershipStatus) {
    EDoctorPartnershipStatus["Affiliated"] = "AFFILIATED";
    EDoctorPartnershipStatus["Applied"] = "APPLIED";
    EDoctorPartnershipStatus["Applying"] = "APPLYING";
    EDoctorPartnershipStatus["Approved"] = "APPROVED";
    EDoctorPartnershipStatus["Blocked"] = "BLOCKED";
    EDoctorPartnershipStatus["NotAffiliated"] = "NOT_AFFILIATED";
    EDoctorPartnershipStatus["Rejected"] = "REJECTED";
    EDoctorPartnershipStatus["Revoked"] = "REVOKED";
    EDoctorPartnershipStatus["Unknown"] = "UNKNOWN";
})(EDoctorPartnershipStatus || (EDoctorPartnershipStatus = {}));
var convertDoctorPartnershipStatus = function(partnershipStatus) {
    try {
        switch(partnershipStatus){
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Affiliated */ .lyM.Affiliated:
                return EDoctorPartnershipStatus.Affiliated;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Applied */ .lyM.Applied:
                return EDoctorPartnershipStatus.Applied;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Applying */ .lyM.Applying:
                return EDoctorPartnershipStatus.Applying;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Approved */ .lyM.Approved:
                return EDoctorPartnershipStatus.Approved;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Blocked */ .lyM.Blocked:
                return EDoctorPartnershipStatus.Blocked;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.NotAffiliated */ .lyM.NotAffiliated:
                return EDoctorPartnershipStatus.NotAffiliated;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Rejected */ .lyM.Rejected:
                return EDoctorPartnershipStatus.Rejected;
            case _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_0__/* .DoctorPartnershipStatus.Revoked */ .lyM.Revoked:
                return EDoctorPartnershipStatus.Revoked;
            default:
                return (0,_shared_utils_typeGuard__WEBPACK_IMPORTED_MODULE_2__/* .exhaustiveGuard */ .Y)(partnershipStatus);
        }
    } catch (e) {
        return EDoctorPartnershipStatus.Unknown;
    }
};
var useGetHospitalById = function(hospitalPid) {
    var ref = (0,_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetHospitalByIdQuery */ .dr)({
        publicId: hospitalPid
    }, {
        select: convertToHospitalResponse,
        staleTime: 1000 * 60 * 5
    }), data = ref.data, isLoading = ref.isLoading, refetch = ref.refetch;
    return {
        data: data,
        refetch: refetch,
        isLoading: isLoading
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetHospitalById);
var prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(queryClient, hospitalPid) {
        var params;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = {
                        publicId: hospitalPid
                    };
                    return [
                        4,
                        queryClient.prefetchQuery(_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetHospitalByIdQuery.getKey */ .dr.getKey(params), _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetHospitalByIdQuery.fetcher */ .dr.fetcher(params))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient, hospitalPid) {
        return _ref.apply(this, arguments);
    };
}();
useGetHospitalById.prefetchQuery = prefetchQuery;
var convertToHospitalResponse = function(data) {
    var _profileImageUrl;
    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, data.getHospitalByPublicId), {
        topRatedDoctorReviews: data.getHospitalByPublicId.topRatedDoctorReviews.map(function(review) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, review), {
                comments: review.comments.map(function(comment) {
                    return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, comment), {
                        reviewCommentHolder: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, comment.reviewCommentHolder), {
                            profileImageUrl: (_profileImageUrl = comment.reviewCommentHolder.profileImageUrl) !== null && _profileImageUrl !== void 0 ? _profileImageUrl : ""
                        })
                    });
                })
            });
        }),
        doctors: data.getHospitalByPublicId.doctors.map(function(doctor) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, doctor), {
                partnershipStatus: convertDoctorPartnershipStatus(doctor.partnershipStatus)
            });
        })
    });
};
var getUseGetHospitalByIdQueryKey = function(hospitalPid) {
    return _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_1__/* .useGetHospitalByIdQuery.getKey */ .dr.getKey({
        publicId: hospitalPid
    });
};
useGetHospitalById.getKey = getUseGetHospitalByIdQueryKey;


/***/ }),

/***/ 78639:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(98788);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22970);
/* harmony import */ var _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(38245);



var useGetTotalReviewCountWithAverageRatingByPublicId = function(hospitalPid) {
    var data = (0,_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetTotalReviewCountWithAverageRatingByPublicIdQuery */ .nR)({
        publicId: hospitalPid
    }, {
        select: convertToHospitalReviewMetricResponse,
        staleTime: 1000 * 60 * 5
    }).data;
    return {
        data: data
    };
};
/* harmony default export */ __webpack_exports__["Z"] = (useGetTotalReviewCountWithAverageRatingByPublicId);
var prefetchQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(function(queryClient, hospitalPid) {
        var params;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_2__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    params = {
                        publicId: hospitalPid
                    };
                    return [
                        4,
                        queryClient.prefetchQuery(_faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetTotalReviewCountWithAverageRatingByPublicIdQuery.getKey */ .nR.getKey(params), _faceToFace_gql_impl__WEBPACK_IMPORTED_MODULE_0__/* .useGetTotalReviewCountWithAverageRatingByPublicIdQuery.fetcher */ .nR.fetcher(params))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return function prefetchQuery(queryClient, hospitalPid) {
        return _ref.apply(this, arguments);
    };
}();
useGetTotalReviewCountWithAverageRatingByPublicId.prefetchQuery = prefetchQuery;
var convertToHospitalReviewMetricResponse = function(data) {
    var _getTotalReviewCountWithAverageRatingByPublicId = data.getTotalReviewCountWithAverageRatingByPublicId, averageRating = _getTotalReviewCountWithAverageRatingByPublicId.averageRating, totalCount = _getTotalReviewCountWithAverageRatingByPublicId.totalCount;
    return {
        averageRating: averageRating,
        totalCount: totalCount
    };
};


/***/ }),

/***/ 77042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _hospitalPid_; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(55351);
// EXTERNAL MODULE: ../../node_modules/next/dynamic.js
var dynamic = __webpack_require__(25237);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ../../node_modules/next/head.js
var head = __webpack_require__(97729);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ../../node_modules/next/router.js
var next_router = __webpack_require__(5632);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ./src/components/layouts/DefaultLayout.tsx
var DefaultLayout = __webpack_require__(83651);
// EXTERNAL MODULE: ./src/constants/dd-actions/f2f/index.ts
var f2f = __webpack_require__(46092);
// EXTERNAL MODULE: ./src/constants/pixel.ts
var pixel = __webpack_require__(4380);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(70865);
// EXTERNAL MODULE: ../../node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(87394);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
// EXTERNAL MODULE: ../../node_modules/recoil/es/index.js
var es = __webpack_require__(53476);
// EXTERNAL MODULE: ./src/recoil/atoms/common/popup.ts
var popup = __webpack_require__(17454);
// EXTERNAL MODULE: ./src/types/common.ts
var common = __webpack_require__(70138);
// EXTERNAL MODULE: ./src/utils/date.ts
var date = __webpack_require__(30918);
// EXTERNAL MODULE: ./src/utils/logger/index.ts
var logger = __webpack_require__(78287);
// EXTERNAL MODULE: ./src/utils/mobile/RNPlugins.tsx
var RNPlugins = __webpack_require__(10712);
// EXTERNAL MODULE: ./src/utils/url.ts
var url = __webpack_require__(74735);
// EXTERNAL MODULE: ./src/hooks/useNavigate.ts + 1 modules
var useNavigate = __webpack_require__(85180);
;// CONCATENATED MODULE: ./src/hooks/hospital/detail/useHospitalDetailNoticePopupViewModel.tsx













var useHospitalDetailNoticePopupViewModel = function() {
    var router = (0,next_router.useRouter)();
    var pageName = (0,logger/* getPageName */.j0)(router);
    var ref = (0,_sliced_to_array/* default */.Z)((0,es.useRecoilState)(popup/* closedHospitalPopupDayState */.y), 2), closedHospitalPopupDay = ref[0], setClosedHospitalPopupDay = ref[1];
    var navigate = (0,useNavigate/* default */.Z)();
    var ref1 = (0,react.useState)(0), currentStep = ref1[0], setCurrentStep = ref1[1];
    var swiperRef = (0,react.useRef)(null);
    var isWebViewLink = (0,RNPlugins/* isWebView */.vp)();
    var hospitalPopupList = (0,react.useMemo)(function() {
        return [];
    }, [
        isWebViewLink
    ]);
    var isClosedTodayHospitalPopup = (0,react.useMemo)(function() {
        if (!closedHospitalPopupDay) return false;
        return (0,date/* isSameDate */.Fo)(closedHospitalPopupDay, "date");
    }, [
        closedHospitalPopupDay
    ]);
    var activePopupList = (0,react.useMemo)(function() {
        return hospitalPopupList.filter(function(popup) {
            return (0,date/* isBetweenDate */.Ut)({
                startAt: popup.startAt,
                endAt: popup.endAt,
                unitType: "minutes"
            });
        });
    }, [
        hospitalPopupList
    ]);
    var onChangeStep = function(step) {
        setCurrentStep(step);
    };
    var onClosePopupToday = function() {
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "click_hospital_popup_close_today"
        });
        var today = dayjs_min_default()().format();
        setClosedHospitalPopupDay(today);
    };
    var openLink = function(popup) {
        if (common/* isServer */.sk) {
            return;
        }
        onClosePopupToday();
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "hospital_popup_click",
            payload: {
                link: popup.link
            }
        });
        if (popup.isExternalLink) {
            navigate.navigateToExternalBrowser({
                url: popup.link
            });
            return;
        }
        if (isWebViewLink) {
            (0,RNPlugins/* sendPostMessageToNative */.T0)(popup.isSameRouter ? RNPlugins/* NATIVE_POST_MESSAGE_TYPE.REPLACE_TO_PAGE */.nn.REPLACE_TO_PAGE : RNPlugins/* NATIVE_POST_MESSAGE_TYPE.MOVE_TO_PAGE */.nn.MOVE_TO_PAGE, (0,_object_spread/* default */.Z)({
                screenName: popup.link
            }, popup.payload && {
                params: (0,_object_spread/* default */.Z)({}, popup.payload)
            }));
            return;
        }
        router.push("".concat(popup.link).concat((0,url/* addQueryString */.sC)(popup.payload)));
    };
    var isClosedPopup = function() {
        return !activePopupList.length || isClosedTodayHospitalPopup;
    };
    var popupPageViewLogger = function() {
        (0,logger/* faceTofaceLogger */.vS)({
            pageName: pageName,
            eventName: "hospital_popup_view"
        });
    };
    return {
        swiperRef: swiperRef,
        activePopupList: activePopupList,
        currentStep: currentStep,
        isClosedPopup: isClosedPopup,
        onChangeStep: onChangeStep,
        onClosePopupToday: onClosePopupToday,
        openLink: openLink,
        popupPageViewLogger: popupPageViewLogger
    };
};
/* harmony default export */ var detail_useHospitalDetailNoticePopupViewModel = (useHospitalDetailNoticePopupViewModel);

// EXTERNAL MODULE: ./src/hooks/cuj/useAppDownloadCujModal.tsx + 1 modules
var useAppDownloadCujModal = __webpack_require__(11989);
// EXTERNAL MODULE: ./src/parsers/f2f/common/index.ts
var f2f_common = __webpack_require__(89325);
// EXTERNAL MODULE: ./src/hooks/hospital/useGetHospitalById.ts
var useGetHospitalById = __webpack_require__(56478);
// EXTERNAL MODULE: ./src/hooks/hospital/useGetTotalReviewCountWithAverageRatingByPublicId.ts
var useGetTotalReviewCountWithAverageRatingByPublicId = __webpack_require__(78639);
;// CONCATENATED MODULE: ./src/hooks/hospital/useHospitalPageViewModel.ts





var useHospitalPageViewModel = function(hospitalPid) {
    var ref = (0,useGetHospitalById/* default */.Z)(hospitalPid), hospital = ref.data;
    var ref1 = (0,useGetTotalReviewCountWithAverageRatingByPublicId/* default */.Z)(hospitalPid), reviewData = ref1.data;
    var setIsCujModalTrackingInfo = (0,useAppDownloadCujModal/* default */.Z)().setIsCujModalTrackingInfo;
    var ref2;
    var hospitalPartnership = new f2f_common/* HospitalPartnership */.JP((ref2 = hospital === null || hospital === void 0 ? void 0 : hospital.partnershipTemplate) !== null && ref2 !== void 0 ? ref2 : false);
    (0,react.useEffect)(function() {
        if (!hospital) {
            return;
        }
        setIsCujModalTrackingInfo({
            campaignName: "web_hospitals",
            trackContent: "web_mid_mdl_details",
            contentId: hospitalPid,
            contentTitle: hospital.name
        });
    }, [
        hospital
    ]);
    return {
        hospital: hospital,
        hospitalPartnership: hospitalPartnership,
        reviewData: reviewData
    };
};
/* harmony default export */ var hospital_useHospitalPageViewModel = (useHospitalPageViewModel);

// EXTERNAL MODULE: ./src/hooks/useLogger.ts
var useLogger = __webpack_require__(8202);
// EXTERNAL MODULE: ./src/parsers/common/index.ts
var parsers_common = __webpack_require__(61169);
// EXTERNAL MODULE: ./src/utils/format.ts
var format = __webpack_require__(4611);
;// CONCATENATED MODULE: ./src/components/common/scroll-restoration-disabler/index.tsx


var ScrollRestorationDisabler = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
            dangerouslySetInnerHTML: {
                __html: 'history.scrollRestoration = "manual"'
            }
        })
    });
};
/* harmony default export */ var scroll_restoration_disabler = (ScrollRestorationDisabler);

// EXTERNAL MODULE: ./src/components/templates/f2f/common/hospital-notice-popup/index.tsx
var hospital_notice_popup = __webpack_require__(30683);
// EXTERNAL MODULE: ./src/utils/pixel/pixel.ts
var pixel_pixel = __webpack_require__(5863);
;// CONCATENATED MODULE: ./src/pages/hospitals/[hospitalPid]/index.tsx
// PageDescription: 병원 상세 페이지


















var HospitalDetailView = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9040), __webpack_require__.e(2707), __webpack_require__.e(1093), __webpack_require__.e(5094), __webpack_require__.e(9653), __webpack_require__.e(7292), __webpack_require__.e(6409), __webpack_require__.e(7808), __webpack_require__.e(5846), __webpack_require__.e(6887)]).then(__webpack_require__.bind(__webpack_require__, 86887));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(86887)
            ];
        }
    }
});
var HospitalDetailPage = function(props) {
    var hospitalPid = props.hospitalPid, client = props.client;
    var router = (0,next_router.useRouter)();
    var log = (0,useLogger/* default */.Z)().log;
    var viewModel = hospital_useHospitalPageViewModel(hospitalPid);
    var noticeViewModel = detail_useHospitalDetailNoticePopupViewModel();
    var hospital = viewModel.hospital;
    var hospitalJson = (0,format/* createHospitalLdJson */.pg)(viewModel.hospital, viewModel.reviewData, hospitalPid);
    var isPartnership = viewModel.hospitalPartnership.isPartnership();
    (0,react.useEffect)(function() {
        var type = Array.isArray(router.query.type) ? router.query.type.join(",") : router.query.type;
        pixel_pixel/* default.trackCustom */.Z.trackCustom(pixel/* EPixelEventName.PageIn */.$.PageIn, {});
        log({
            eventName: f2f/* FaceToFaceDdAction.PageViewHospitalDetail */.r.PageViewHospitalDetail,
            payload: {
                type: type !== null && type !== void 0 ? type : "default",
                partnership: viewModel.hospitalPartnership.getPartnershipAsString(),
                platform: (0,parsers_common/* parseRumClientType */.LY)(client)
            }
        });
    }, []);
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(hospitalJson)
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, " 위치 \xb7 후기 \xb7 예약 - 닥터나우"),
                description: "".concat((hospital === null || hospital === void 0 ? void 0 : hospital.partnershipTemplate) ? "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.regionByDepth.eupMyeonDongName, " ").concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, "에서, ").concat(hospital.departmentGroups.slice(0, 3).map(function(departmentGroup) {
                    return departmentGroup.departmentGroupName;
                }).join(", "), " 진료를 바로 예약할 수 있어요. 76,614개 병원이 모인 닥터나우에서 내게 딱 맞는 병원을 찾아보세요!") : "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.regionByDepth.eupMyeonDongName, " ").concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, "에서, ").concat(((ref = hospital === null || hospital === void 0 ? void 0 : hospital.departmentsV2) !== null && ref !== void 0 ? ref : []).slice(0, 3).map(function(department) {
                    return department.departmentName;
                }).join(", "), " 진료를 바로 예약할 수 있어요. 76,614개 병원이 모인 닥터나우에서 내게 딱 맞는 병원을 찾아보세요!")),
                canonical: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospitalPid),
                openGraph: {
                    url: "".concat("https://doctornow.co.kr").concat(common/* ROUTES.HOSPITAL.DETAIL.path */.Z6.HOSPITAL.DETAIL.path).concat(hospitalPid),
                    title: "".concat(hospital === null || hospital === void 0 ? void 0 : hospital.name, " - 닥터나우"),
                    description: "병원 위치부터 후기까지 확인 후, 예약해 보세요!",
                    images: [
                        {
                            url: "".concat("https://media.doctornow.co.kr/hospital_logo.png"),
                            alt: "Og Image Alt"
                        }, 
                    ]
                },
                twitter: {
                    handle: "@doctornow",
                    site: "@doctornow.co.kr",
                    cardType: "summary_large_image"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(scroll_restoration_disabler, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HospitalDetailView, {
                hospitalPid: hospitalPid,
                isPartnership: isPartnership,
                client: client
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(hospital_notice_popup/* default */.Z, {
                enabled: !client.isWebView,
                viewModel: noticeViewModel
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _hospitalPid_ = (HospitalDetailPage);
HospitalDetailPage.Layout = DefaultLayout/* default */.Z;


/***/ }),

/***/ 61169:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ parseContactTypeOf; },
/* harmony export */   "Kv": function() { return /* binding */ parseFamilyRelationOf; },
/* harmony export */   "LY": function() { return /* binding */ parseRumClientType; },
/* harmony export */   "Zl": function() { return /* binding */ convertToCurrencyCommaString; },
/* harmony export */   "dl": function() { return /* binding */ parseMedicalCategoryTypeOf; },
/* harmony export */   "hk": function() { return /* binding */ parseDeprecatedMedicalCategoryCategoryTypeOf; },
/* harmony export */   "x3": function() { return /* binding */ parseMedicalCategoryCategoryTypeOf; },
/* harmony export */   "yB": function() { return /* binding */ parseDiagnosisFormTypeOf; }
/* harmony export */ });
/* harmony import */ var _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7551);
/* harmony import */ var _models_common__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18044);
/* harmony import */ var _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39591);
/* harmony import */ var _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72271);
/* harmony import */ var _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20138);





var parseRumClientType = function(client) {
    if (!client.isMobile) {
        return client.clientType;
    }
    if (client.isIOS) {
        return "".concat(client.clientType, "-iOS");
    }
    return "".concat(client.clientType, "-Android");
};
var parseDiagnosisFormTypeOf = function(diagnosisFormType) {
    switch(diagnosisFormType){
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDiagnosisFormType.General */ .fL.General:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.General */ .qRY.General;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DoctorDiagnosisFormType.InHospitalDelivery */ .fL.InHospitalDelivery:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.InHospitalDelivery */ .qRY.InHospitalDelivery;
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisFormType.General */ .qRY.General;
    }
};
var parseMedicalCategoryTypeOf = function(type) {
    switch(type){
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Department */ .P2.Department:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Treatment */ .P2.Treatment:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Treatment */ .WkB.Treatment;
        case _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Vaccination */ .P2.Vaccination:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Vaccination */ .WkB.Vaccination;
    }
};
var parseMedicalCategoryCategoryTypeOf = function(type) {
    switch(type){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Department */ .WkB.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Treatment */ .WkB.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .MedicalCategoryType.Vaccination */ .WkB.Vaccination;
    }
};
var parseDeprecatedMedicalCategoryCategoryTypeOf = function(type) {
    switch(type){
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.DEPARTMENT */ .m1.DEPARTMENT:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Department */ .P2.Department;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.TREATMENT */ .m1.TREATMENT:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Treatment */ .P2.Treatment;
        case _entities_medical_category__WEBPACK_IMPORTED_MODULE_0__/* .EMedicalCategoryType.VACCINATION */ .m1.VACCINATION:
            return _models_diagnosis__WEBPACK_IMPORTED_MODULE_2__/* .DiagnosisCategoryType.Vaccination */ .P2.Vaccination;
    }
};
var parseFamilyRelationOf = function(relation) {
    switch(relation){
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Children */ .h6.Children:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Children */ .dDP.Children;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Parents */ .h6.Parents:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Parents */ .dDP.Parents;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Me */ .h6.Me:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Me */ .dDP.Me;
        case _models_common__WEBPACK_IMPORTED_MODULE_1__/* .UserProfileRelationType.Spouse */ .h6.Spouse:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .FamilyRelation.Spouse */ .dDP.Spouse;
    }
};
var parseContactTypeOf = function(contactType) {
    switch(contactType){
        case _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__/* .EDiagnosisContactType.F2F */ .d.F2F:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisContactType.F2F */ .qnl.F2F;
        case _types_diagnosis__WEBPACK_IMPORTED_MODULE_4__/* .EDiagnosisContactType.NonF2F */ .d.NonF2F:
        default:
            return _types_bff_gql_schema__WEBPACK_IMPORTED_MODULE_3__/* .DiagnosisContactType.NonF2F */ .qnl.NonF2F;
    }
};
var convertToCurrencyCommaString = function(amount) {
    return amount.toLocaleString("en");
};


/***/ }),

/***/ 95214:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ exhaustiveGuard; }
/* harmony export */ });
function exhaustiveGuard(_value) {
    throw new Error("ERROR! Reached forbidden guard function with unexpected value: ".concat(JSON.stringify(_value)));
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7506,8185,8141,9774,2888,179], function() { return __webpack_exec__(82887); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);